import { useItemSet } from '@exam-management/common/item-set-provider';
import { useSnackbar } from '@shared/snackbar';

import {
  ItemSetSubQuestionDeletionModal,
  type ItemSetSubQuestionDeletionModalProps,
} from '../../components';

interface ItemSetSubQuestionDeletionModalLogicProps
  extends Pick<ItemSetSubQuestionDeletionModalProps, 'open' | 'onClose'> {
  subQuestionId: string;
}

export default function ItemSetSubQuestionDeletionModalLogic(
  props: Readonly<ItemSetSubQuestionDeletionModalLogicProps>,
) {
  const { open: isOpen, onClose, subQuestionId } = props;

  const { deleteSubQuestion, isDeleting } = useItemSet();
  const { showSnackbar } = useSnackbar();

  const handleAccept: React.MouseEventHandler<HTMLButtonElement> = async (event) => {
    await deleteSubQuestion(subQuestionId, {
      onCompleted: () => {
        showSnackbar({
          message: 'Sub-Question has been deleted',
          variant: 'success',
        });
        onClose?.(event);
      },
      onError: () => {
        showSnackbar({
          message: 'Unable to Delete Sub-Question',
          variant: 'error',
        });
        onClose?.(event);
      },
    });
  };

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClose?.(event);
  };

  return (
    <ItemSetSubQuestionDeletionModal
      open={isOpen}
      loading={isDeleting}
      onClose={handleClose}
      onAccept={handleAccept}
    />
  );
}
